const CarouselListReducers = (state = [], action) => {
  switch (action.type) {
    case "storeCarouselList":
      return action.payload;
    default:
      return state;
  }
};
export default CarouselListReducers;
